import React, { FunctionComponent } from 'react';
import { faCommentDollar, faComments } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '.';

const IconCommentsDots: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faCommentDollar} />;

export { IconCommentsDots };
